export function attachVoiceAudio(track, onAudioStart) {
  const element = track.attach()
  element.autoplay = true
  element.dataset.doChatVoice = 'true'
  element.addEventListener('playing', onAudioStart, { once: true })
  document.body.append(element)
  return () => {
    element.removeEventListener('playing', onAudioStart)
    track.detach(element)
    element.remove()
  }
}
